// extracted by mini-css-extract-plugin
export default {"container":"HapaxForm_container__dUQpl","field-container":"HapaxForm_field-container__oq-OE","text-input":"HapaxForm_text-input__8ocSB","label":"HapaxForm_label__a0Pdj"};